import { useEffect, useState } from 'react';

import { useRouter } from 'next/router';

import { setSessionStorage } from 'src/components/player/src/utils/Utils';
import { purchasePlan } from 'src/services/responseTypes/purchasePlanResponse';
import {
  REDIRECT_URL_TO_CONSUMPTION,
  SELECTED_PLAN,
  USER_TOKEN
} from 'src/utils/constants/localStorageConstants';
import { TAG_NAME } from 'src/utils/constants/TagNameConstants';
import { FeatureFlagConstants } from 'src/utils/constants/utilConstants';
import { getDeviceWidth } from 'src/utils/getDeviceWidth';
import { getImageURL } from 'src/utils/ImageHelper/ImageURLGenerator';
import { isFeatureEnabled } from 'src/utils/RemoteConfig';
import {
  getPlanMatchingTier,
  prepareTvodPaymentData
} from 'src/utils/TvodHelper/tvodHelper';

import { useAppStore } from 'src/hooks/useAppStore';
import { BestOffering } from '../../../../services/responseTypes/plansMetaDataResponse';
import { mixpanelObject } from '../../../../utils/analytics/mixpanel/mixpanel';
import {
  MIXPANEL_BUTTON_TYPE,
  MIXPANEL_ELEMENT,
  MIXPANEL_EVENTS_PLAYER_CTAS,
  MIXPANEL_LOGIN,
  MIXPANEL_SKIP
} from '../../../../utils/analytics/mixpanel/mixpanelConstants';
import { playerCtaEvent } from '../../../../utils/analytics/mixpanel/mixpanelEventsHelper';
import { clearCtaEventsProperty } from '../../../../utils/analytics/mixpanel/mixpanelHelper';
import {
  getLocalStorage,
  getLocalStorageInteger,
  setLocalStorage
} from '../../../../utils/browserStorageHandler';
import { CountryCode } from '../../../../utils/constants/stringConstants';
import { getsubscribeToPremium } from '../../../../utils/playerHelper';
import { gotoLogin, goToSubscription } from '../playerCallbacks';
import NewTvodPopup from './newTvodPopup';

type SvodOrTvodPopupProps = {
  playerRef: any;
  closePopUp: any;
  toggleTeaserSubscriptionPopup: any;
};

const SvodOrTvodPopup = ({
  playerRef,
  toggleTeaserSubscriptionPopup
}: SvodOrTvodPopupProps) => {
  const {
    singlePlayDetails = {},
    playerConfig = {},
    similarFromReco
  } = playerRef || {};
  const isPartnerContent =
    !!singlePlayDetails?.assetDetails?.content_partner_details
      ?.content_partner_id;
  const partnerDetails =
    singlePlayDetails?.assetDetails?.content_partner_details || {};
  const {
    content_partner_id: partnerId = '',
    content_partner_name: partnerName = '',
    content_partner_images = {}
  } = partnerDetails;
  const router = useRouter();

  const { setPopups, tvodRentals, comboOfferState, bestOfferingPlan } =
    useAppStore();
  const [tvodRentalPlanDetails, setTvodRentalPlanDetails] = useState<
    purchasePlan[]
  >([]);
  const {
    assetDetails: {
      billing_type = '',
      business_type = '',
      content_partner_details = {},
      id = ''
    } = {},
    entitlement: { isTVOD = 0 } = {}
  } = singlePlayDetails || {};
  const {
    userData = {},
    setVITvod = null,
    country = 'IN',
    userType = 'guest',
    tvodState = null,
    remoteConfig,
    requestToPlayNextVideo
  } = playerConfig || {};

  const user = userData?.user || {};

  const isTVODFlag = isTVOD || singlePlayDetails.error_code === '604';

  let userValue;
  const { messages = {}, aggregator = {} } =
    window.translationsAndConfigs || {};

  const userToken = getLocalStorage(USER_TOKEN);

  useEffect(() => {
    const tvodTierPlanDetails =
      singlePlayDetails?.assetDetails &&
      getTvodPlanDetails(singlePlayDetails?.assetDetails?.tier);
    if (tvodTierPlanDetails) {
      setTvodRentalPlanDetails(tvodTierPlanDetails);
    }
  }, [tvodState]);

  const getTvodPlanDetails = (tierName: string) => {
    if (tierName && tvodRentals?.tvodPlans) {
      const filteredTierPlan: purchasePlan[] = getPlanMatchingTier(
        tierName,
        tvodRentals.tvodPlans
      );
      filteredTierPlan[0] = {
        ...filteredTierPlan[0],
        price: Number(tvodState.tvodPriceObj?.price)
      };
      return filteredTierPlan;
    }
  };

  const submitHandler = () => {
    const isLoggedIn = getLocalStorage(USER_TOKEN) ? true : false;
    // submitMixpanelEvent(buttonText, item);
    if (tvodRentalPlanDetails && tvodRentalPlanDetails.length) {
      const selectPlan = prepareTvodPaymentData(
        tvodRentalPlanDetails,
        singlePlayDetails?.assetDetails,
        singlePlayDetails?.assetDetails?.license_expiry_date
      );
      setLocalStorage(SELECTED_PLAN, selectPlan);
      if (isLoggedIn) {
        window.location.href = '/myaccount/payment';
      } else {
        window.location.href = '/myaccount/account-info';
      }
    }
  };

  const createSubscribeBlock = () => {
    let subscribeText: string;
    let buyBtnText: string;
    let buyBtnId = '';

    if (getLocalStorage('entitlementUserType')) {
      userValue = getLocalStorage('entitlementUserType');
    } else {
      userValue = userType;
    }
    switch (userValue) {
      case 'guest':
      case 'register':
        if (billing_type === 'club') {
          subscribeText = messages.youNeedClubMembership;
          buyBtnText = messages.subscribeToClub;
        } else {
          subscribeText = messages.youNeedPremiumMembership;
          buyBtnText = getsubscribeToPremium(
            country,
            bestOfferingPlan as BestOffering
          );
          buyBtnId = 'subscribe-register-btn-svod-popup';
        }
        break;
      case 'club':
      case 'RSVOD':
        subscribeText =
          messages.Player_Message_ContentNotPartofCurrentPlan_Text;
        buyBtnText = messages.Upgrade_to_Premium_Label;
        buyBtnId = 'subscribe-btn-rsvod-popup';
        break;
      default:
        subscribeText = messages.youNeedPremiumMembership;
        buyBtnText = getsubscribeToPremium(country);
        buyBtnId = 'subscribe-btn-svod-popup';
        break;
    }
    if (isPartnerContent) {
      buyBtnText = aggregator.PartnerConsumption_AddOnUnsubscribedUser_CTA;
      buyBtnId = 'partner-subscribe-btn-popup';
      if (/premium/i.test(userType)) {
        buyBtnText = aggregator.PartnerConsumption_AddOnSubscribedUser_CTA;
        buyBtnId = 'get-add-on-btn-popup';
      }
    }
    if (isTVODFlag && tvodState) {
      if (country.toLowerCase() !== 'in') {
        subscribeText =
          messages.DetailsPage_PlayerOverlay_PLexText1_Text_global;
      } else {
        subscribeText = messages.DetailsPage_PlayerOverlay_PLexText1_Text;
      }
      if (comboOfferState && comboOfferState.isComboOfferEnabled) {
        buyBtnText = messages.Player_Rent_CTA;
        buyBtnId = 'rent-btn-popup';
      } else if (messages.DetailsPage_PlayerOverlay_PLexText2_Text) {
        let rentString = messages.DetailsPage_PlayerOverlay_PLexText2_Text;
        rentString = rentString.replace(
          '{{currency}}',
          tvodState && tvodState?.tvodPriceObj?.currency
        );
        rentString = rentString.replace(
          '{{amount}}',
          tvodState && tvodState?.tvodPriceObj?.price
        );
        buyBtnText = rentString;
        buyBtnId = 'rent-btn-popup';
      }
    }

    let buyBtnClass = '';
    if (comboOfferState && comboOfferState.isComboOfferEnabled) {
      buyBtnClass = `subscribe-button buy-plan-btn subscribemsg_{messages.localeLanguage} comboRentNow`;
    } else if (!isTVOD) {
      buyBtnClass = `subscribe-button buy-plan-btn subscribemsg_{messages.localeLanguage} noPremiumIcon`;
    } else {
      buyBtnClass = `subscribe-button subscribemsg_{messages.localeLanguage}`;
    }
    if (isPartnerContent) {
      buyBtnClass = `${
        /premium/i.test(userType) ? 'partnerAddOn' : ''
      } removePremiumIcon subscribe-button buy-plan-btn subscribemsg_${
        messages.localeLanguage
      } noPremiumIcon`;
    }
    return (
      <div>
        <div className="subscribe-msg-premium subscribemsg_{messages.localeLanguage}">
          {subscribeText}
        </div>
        <div
          data-testid={buyBtnId}
          className={buyBtnClass}
          onClick={() => buyPlanBtnClick(buyBtnText)}>
          {buyBtnText}
        </div>
      </div>
    );
  };
  const createAccountMessage = () => {
    let accountText = '';
    const isPartnerContent = !!content_partner_details?.content_partner_id;
    if (Object.keys(messages).length) {
      accountText = isPartnerContent
        ? messages.Existing_Users
        : messages.ALREADY_ACCOUNT;
    }
    return (
      <div
        className={`alreadyHave-msg subscribemsg_${messages.localeLanguage}`}>
        <div>
          <span>{accountText}</span>
        </div>
      </div>
    );
  };
  const createLoginButton = () => {
    return (
      <div data-testid="login-btn-popup" className="login-link-wrap">
        <span className="login-link" onClick={() => loginClick()}>
          {messages.Login_Button}
        </span>
      </div>
    );
  };
  const createSkipButton = () => {
    const { similarFromReco = [] } = playerRef || {};
    const mandatoryRegistrationPopupCount = getLocalStorageInteger(
      'mandatoryRegistrationPopupCount'
    );
    const skipDiv2 = document.querySelector('.skip-button-2');
    if (
      !(
        mandatoryRegistrationPopupCount && mandatoryRegistrationPopupCount >= 5
      ) &&
      Object.keys(messages).length &&
      similarFromReco &&
      similarFromReco[0] &&
      similarFromReco[0].id &&
      !skipDiv2 &&
      !isPartnerContent
    ) {
      return (
        <div
          data-testid="skip-button-popup"
          className={`skip-button subscribe-link subscribemsg_${messages.localeLanguage}`}
          onClick={() => skipClick()}>
          {messages.Player_Skip_UnsubscribedUser_Text}
        </div>
      );
    }
  };

  const loginClick = () => {
    setSessionStorage(REDIRECT_URL_TO_CONSUMPTION, window.location.pathname);
    clearCtaEventsProperty(mixpanelObject);
    mixpanelObject[MIXPANEL_ELEMENT] = MIXPANEL_LOGIN;
    mixpanelObject[MIXPANEL_BUTTON_TYPE] = MIXPANEL_EVENTS_PLAYER_CTAS;
    playerCtaEvent();
    gotoLogin();
  };

  const buyPlanBtnClick = (ctaString: string) => {
    // const { partner_name: partnerName = '' } = partnerSetting;
    const isComboOfferEnabled =
      comboOfferState && comboOfferState.isComboOfferEnabled;
    const isRevisedSubscriptionJourney =
      isFeatureEnabled(
        remoteConfig,
        FeatureFlagConstants.FEATURE_GUEST_SUBSCRIPTION_JOURNEY
      ) || false;

    if (isPartnerContent) {
      let currentPath = '/';
      const isGuestUser = /guest/i.test(userType);
      const isPremiumUser = /premium/i.test(userType);
      // TODO:: get current consumption page pat and pass it to currentPath to redirect user
      // to consumption page if he has already subscribed to partner
      if (window && typeof window !== 'undefined') {
        currentPath = window.location.pathname;
      }
      setSessionStorage('partnerPlanDetails', {
        partnerId,
        partnerName,
        partnerCollectionId: '',
        currentPath,
        redirectToSubscription: isGuestUser,
        content_partner_images
      });
      if (isGuestUser) {
        window.location.href = '/signin';
      } else if (isPremiumUser) {
        window.location.href = `/myaccount/partnersubscriptions/${partnerName}/${partnerId}`;
      } else {
        window.location.href = '/myaccount/subscription';
      }
    } else if (
      user &&
      user.additional &&
      user.additional.partner &&
      user.additional.partner === 'ViMTVApp'
    ) {
      setPopups({ isViTvod: true });
    } else if (partnerName === 'ViMTVApp') {
      setVITvod({ isViTvod: true });
    } else if (
      // window.isRevisedSubscriptionJourney has been replced  with getRevisedSubscriptionJourneyFlag
      isRevisedSubscriptionJourney &&
      country &&
      country.toLowerCase() === 'in' &&
      (business_type === 'premium' ||
        business_type === 'premium_downloadable' ||
        billing_type === 'club' ||
        billing_type === 'premium')
    ) {
      // toggleSubscriptionPopup() is deprecated in favor of toggleTeaserSubscriptionPopup
      toggleTeaserSubscriptionPopup(true);
      playerCtaEvent();
    } else if (!isTVODFlag || isComboOfferEnabled) {
      ctaString = isComboOfferEnabled ? 'Rent Now' : ctaString;
      clearCtaEventsProperty(mixpanelObject);
      mixpanelObject[MIXPANEL_ELEMENT] = ctaString;
      mixpanelObject[MIXPANEL_BUTTON_TYPE] = MIXPANEL_EVENTS_PLAYER_CTAS;
      playerCtaEvent();
      if (country.toLowerCase() !== 'in' && !isComboOfferEnabled) {
        goToSubscription({ country, router, tvodState });
      } else if (isComboOfferEnabled) {
        window.location.href = `/offers/${id}`;
      }
    } else if (isTVODFlag) {
      submitHandler();
    }
  };

  const skipClick = () => {
    // below function is same as play next function of carousel
    clearCtaEventsProperty(mixpanelObject);
    mixpanelObject[MIXPANEL_ELEMENT] = MIXPANEL_SKIP;
    mixpanelObject[MIXPANEL_BUTTON_TYPE] = MIXPANEL_EVENTS_PLAYER_CTAS;
    playerCtaEvent();
    requestToPlayNextVideo({
      contentid: similarFromReco[0].id,
      indexObject: undefined,
      playerRef,
      similarFromReco
    });
  };
  const imageNode = singlePlayDetails?.assetDetails?.image || {};
  const assetType = singlePlayDetails?.assetDetails?.assetType || '';
  const assetID = singlePlayDetails?.assetDetails?.id || '';
  const title = singlePlayDetails?.assetDetails?.title || '';

  const imageURL = getImageURL({
    tagName: TAG_NAME.PLAYER_POSTER,
    deviceWidth: getDeviceWidth() || 0,
    item: {
      image: imageNode,
      id: assetID,
      assetType,
      title
    }
  });

  if (!isTVODFlag && !isTVOD && country === CountryCode.IN)
    return <NewTvodPopup imageURL={imageURL} />;

  return (
    <>
      <div className="main-Inner-container">
        {isTVODFlag && <div className="zeeplex-Logo-container"></div>}
        <div className="section-container main-container-1">
          {createSubscribeBlock()}
          {createSkipButton()}
        </div>
        {!userToken && (
          <div className="section-container main-container-2">
            {createAccountMessage()}
            {createLoginButton()}
          </div>
        )}
      </div>
    </>
  );
};

export default SvodOrTvodPopup;
